import posthog from 'posthog-js'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()

  // don't init posthog if we're in dev mode
  if (runtimeConfig.public.ENV === "development") return
  
  posthog.init(runtimeConfig.public.POSTHOG_API_KEY, 
    { 
      api_host: 'https://eu.posthog.com',
      persistence: 'memory',
      disable_session_recording: true,
      opt_in_site_apps: true
      // loaded: function (posthog) {
      //   console.log("Posthog loaded:", posthog)
      //   console.log('supabaseUser.value:', supabaseUser.value);
        
      //   if(supabaseUser.value) {
      //     // record authenticated sessions
      //     posthog.startSessionRecording()
      //   } else {
      //     console.log("Posthog:: No user detected, not recording")
      //   }
      // }
    })

  posthog.onFeatureFlags(function() {
      // feature flags should be available at this point
      // if (posthog.isFeatureEnabled('show_model_preview_genders') ) {
      //     // do something
      //     featureFlags.value.show_model_preview_genders = true
      // }
  })

  nuxtApp.provide('posthog', posthog)
});
